import { ACTIONS } from "../../common/constants";

const ticketTrackerDataReducer = function (state = null, action) {
  switch (action.type) {
    case ACTIONS.SET_TICKET_TRACKER_DATA:
      return action.data;
    default:
      return state;
  }
};

export default ticketTrackerDataReducer;
